import type AdditionalCoverage from '@/modules/common/common/models/APP/AdditionalCoverage'
import Insured from '@/modules/common/common/models/APP/Insured'
import RaterPriceClientProduct from '@/modules/common/common/models/MID/RaterPriceClientProduct'
import CommonMapper from '@/modules/core/mappers/CommonMapper'
import HealthRaterPriceRequest from '@/modules/health/common/models/MID/requests/HealthRaterPriceRequest'
import type HealthRaterAnswers from '@/modules/health/rater/models/APP/HealthRaterAnswers'
import HealthRaterPriceInsuredToSave from '../../models/MID/HealthRaterPriceInsuredToSave'

export default class GetPricingMapper {
  static toRequest(
    data: HealthRaterAnswers,
    isQuote: boolean = false,
    mediator?: string
  ): HealthRaterPriceRequest {
    const clientProduct: RaterPriceClientProduct[] = []

    // const insureds = this.#mountInsureds(data.insureds, data.coverage)
    // insureds.forEach((insured) => {
    //   insured.optionalCoverage?.forEach((coverage) => {
    //     if (!coverage.sumInsured) {
    //       console.log(`La cobertura ${coverage.coverageCode} requiere un valor para sumInsured.`)
    //     }
    //   })
    // })

    if (data?.product) {
      clientProduct.push(
        new RaterPriceClientProduct({
          clientCode: data?.product.clientCode,
          productCode: data?.product.productCode
        })
      )
    }

    return new HealthRaterPriceRequest({
      quotationId: data.quotationId ?? undefined,
      quotationNumber: data.product?.quotationNumber || undefined,
      businessLine: data?.businessLine ?? 'AS02',
      insuranceStartDate: CommonMapper.toMiddlewareDate(data.startDate)!,
      insuranceType: data.insuranceType!,
      policyHolderPostal: data.holder.addressDetails.postalCode!,
      insureds: this.#mountInsureds(data.insureds, data.coverage),
      stayAbroadType: data.abroadOption,
      clientProduct: clientProduct.length ? clientProduct : null,
      isQuote,
      mediator
    })
  }

  static #mountInsureds(insureds: Insured[], coverageKey: string | null) {
    return insureds.map((i, order) => {
      const coverages = this.#setCoverages(coverageKey, i.additionalCoverages)
      const optionalCoverage = coverages.length ? coverages : undefined

      return new HealthRaterPriceInsuredToSave({
        postalCode: i.addressDetails.postalCode!,
        birthDate: CommonMapper.toMiddlewareDate(i.userDetails.birthDate)!,
        riskNumber: String(order + 1),
        optionalCoverage
      })
    })
  }

  static #setCoverages(coverageKey: string | null, additionalCoverages: AdditionalCoverage[]) {
    if (coverageKey) {
      return [
        {
          coverageCode: coverageKey,
          sumInsured: null
        }
      ]
    }
    return additionalCoverages
      .filter((i) => i.checked)
      .map((c) => ({
        coverageCode: c.key,
        sumInsured: c.value ? String(c.value) : null
      }))
  }
}
